import React from 'react';
import P, { InferProps } from 'prop-types';
import { Link } from 'react-router-dom';
import { ListItemButton, ListItemText } from '@mui/material';

export default function ListItemLink({
  primary,
  secondary,
  to,
}: InferProps<typeof ListItemLink.propTypes>) {
  const CustomLink = React.useMemo(
    () =>
      React.forwardRef((linkProps, ref: any) => (
        <Link ref={ref} to={to} {...linkProps} title={primary} />
      )),
    [primary, to]
  );

  return (
    <li>
      <ListItemButton component={CustomLink}>
        <ListItemText primary={primary} secondary={secondary} />
      </ListItemButton>
    </li>
  );
}

ListItemLink.propTypes = {
  to: P.string.isRequired,
  primary: P.string.isRequired,
  secondary: P.string,
};
